import React, { Component } from 'react';
import {
  Grid,
  Cell,
  Card,
  DialogContainer,
  FontIcon,
  Tooltipped,
} from 'react-md';
import numeral from 'numeral';
import { trackEvent } from '../../util/analytics';
import './StarsCard.scss';

class StarsCard extends Component {
  state = { visible: false };

  show = () => {
    this.setState({ visible: true });
    trackEvent({
      category: 'Stars',
      action: 'Show',
    });
  };

  hide = () => {
    this.setState({ visible: false });
    trackEvent({
      category: 'Stars',
      action: 'Hide',
    });
  };

  render() {
    const { visible } = this.state;

    const actions = [
      {
        onClick: this.hide,
        primary: true,
        children: 'OK',
      },
    ];

    const attacksBlocked = this.props.bundleSummary.attacks_blocked;
    const reportsReceived = this.props.bundleSummary.reports_received;
    const isAppProtectionCustomer = this.props.bundleSummary
      .is_app_protection_customer;

    var StarsContent = React.createClass({
      formatCount: function(count) {
        if (count < 1000) {
          return count.toString();
        } else if (count % 100 === 0) {
          return numeral(count).format('0.0a');
        }
        return numeral(numeral(count).format('0.0a')).format('0,0');
      },

      render: function() {
        const isActiveMode = attacksBlocked / reportsReceived > 0.3;
        let numberOfStars = 0;

        if (this.props.forceFiveStar) {
          numberOfStars = 5;
        } else {
          if (isAppProtectionCustomer) {
            numberOfStars += 1;
          }

          if (isActiveMode) {
            numberOfStars += 3;
          }
        }
        return (
          <div>
            <Tooltipped
              label="Learn how we calculate your app safety rating"
              setPosition
            >
              <Grid className="stars-grid">
                <Cell size={5} className="stars-grid-cell">
                  <div className="stars-focus stars-grid-inside">
                    <h2
                      className={`stars-num ${
                        isActiveMode ? 'gold' : 'red'
                      }-stars`}
                    >
                      {Array(numberOfStars)
                        .fill()
                        .map((_, i) => <FontIcon key={i}>star</FontIcon>)}
                      {Array(5 - numberOfStars)
                        .fill()
                        .map((_, i) => (
                          <FontIcon key={i}>star_border</FontIcon>
                        ))}
                    </h2>
                    APP SAFETY RATING
                  </div>
                </Cell>
                <Cell size={7} className="stars-grid-cell">
                  <h2 className="stars-prose stars-grid-inside">
                    {isActiveMode
                      ? `Over ${this.formatCount(
                          reportsReceived,
                        )} eavesdropping attacks
                  are being blocked by TrustKit`
                      : `${this.formatCount(
                          reportsReceived,
                        )} of user connections were
                  eavesdropped on by an untrusted 3rd party`}
                  </h2>
                </Cell>
              </Grid>
            </Tooltipped>
          </div>
        );
      },
    });

    return (
      <div>
        <div className="stars-container md-grid mobile-fix">
          <Card
            className="md-block-centered"
            onClick={() => {
              this.show();
            }}
          >
            <StarsContent
              attacksBlocked={attacksBlocked}
              reportsReceived={reportsReceived}
              forceFiveStar={this.props.forceFiveStar}
            />
          </Card>
        </div>
        <DialogContainer
          portal
          id="signup-alert-modal"
          visible={visible}
          title="App Safety Rating System"
          onHide={this.hide}
          aria-describedby="signup-alert-description"
          modal
          actions={actions}
        >
          <Grid className="star-legend-grid">
            <Cell size={3} className="star-legend-icon" />
            <Cell size={3} className="star-legend-prose">
              <b>TrustKit</b>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <b>Critical Alerts</b>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <b style={{ whiteSpace: 'nowrap' }}>App Protection</b>
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 5 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Active
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 4 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Active
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 3.5 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_half</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Active
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 3 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Active
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 2.5 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_half</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Passive
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 2 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Passive
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 1.5 stars */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_half</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Passive
            </Cell>
            <Cell size={3} className="star-legend-prose">
              <FontIcon style={{ color: 'green' }}>check</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>

            <Cell size={3} className="star-legend-icon">
              {' '}
              {/* 1 star */}
              <FontIcon className="small-star">star</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
              <FontIcon className="small-star">star_border</FontIcon>
            </Cell>
            <Cell size={3} className="star-legend-prose">
              Passive
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>
            <Cell size={3} className="star-legend-prose">
              -
            </Cell>
          </Grid>
        </DialogContainer>
      </div>
    );
  }
}

export default StarsCard;



// WEBPACK FOOTER //
// ./src/components/StarsCard/StarsCard.jsx